

















































































































































































































import Vue, { PropType } from 'vue'
import _ from 'lodash'

export default Vue.extend({
  props: {
    searchText: String,
    selectedTags: Array as PropType<string[]>,
    selectedOwners: Array as PropType<string[]>,
    selectedType: String,
    onlyFavorites: Boolean,
    tagOptions: Array as PropType<string[]>,
    ownerOptions: Array as PropType<string[]>,
    typeOptions: Array as PropType<string[]>,
    viewType: String
  },

  computed: {
    hasFilters (): boolean {
      return Boolean(this.searchText || this.selectedTags.length || this.selectedOwners.length || this.selectedType || this.onlyFavorites)
    },

    showBadge (): boolean {
      return Boolean(this.selectedTags.length || this.selectedOwners.length || this.selectedType || this.onlyFavorites)
    },

    formattedSelectedTagsString (): string {
      return this.selectedTags.map(tag => _.startCase(_.lowerCase(tag))).join(';')
    },

    formattedSelectedOwnersString (): string {
      return this.selectedOwners.map(owner => `${owner.split('@')[0]}@`).join(';')
    },

    formattedSelectedType (): string {
      return _.startCase(_.lowerCase(this.selectedType))
    }
  },

  methods: {
    onSearchTextChange: _.debounce(function (searchText: string) {
      // @ts-ignore
      this.$emit('on-search-text-change', searchText)
    }, 500),

    onSelectedTagsChange (selectedTags: string[] = []) {
      this.$emit('on-selected-tags-change', selectedTags)
    },

    onSelectedOwnersChange (selectedOwners: string[] = []) {
      this.$emit('on-selected-owners-change', selectedOwners)
    },

    onSelectedTypeChange (selectedType: string = '') {
      this.$emit('on-selected-type-change', selectedType)
    },

    onOnlyFavoritesChange (onlyFavorites: boolean = false) {
      this.$emit('on-only-favorites-change', onlyFavorites)
    },

    onClearFiltersClick () {
      this.$emit('on-clear-filters')
    },

    onViewTypeChange (viewType: string) {
      this.$emit('on-view-type-change', viewType)
    }
  }
})
